import Contents from "./ContentsBlock.svelte";
import { Node, mergeAttributes } from "@tiptap/core";
import { SvelteNodeViewRenderer } from "svelte-tiptap";
import { SvelteSSRRenderer } from "../../utils";
import { calcYchangeDomAttrs } from "../Collaboration/YChange";
import { type MarkdownSerializerState } from "prosemirror-markdown";
import { type Node as PMNode } from "@tiptap/pm/model";

export default Node.create({
  name: "tableOfContents",
  group: "topBlock",
  defining: true,
  content: "block+",
  marks: "ychange",

  addAttributes() {
    return {
      ychange: {
        default: null,
      },
    };
  },
  parseHTML() {
    return [
      {
        tag: "div[data-type='toc']",
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    return SvelteSSRRenderer("div", Contents, {
      node,
      hasContent: true,
      attributes: mergeAttributes(
        HTMLAttributes,
        { "data-type": "toc" },
        calcYchangeDomAttrs(node.attrs)
      ),
    });
  },

  addStorage() {
    return {
      markdown: {
        serialize: (state: MarkdownSerializerState, node: PMNode) => {
          const headings: string[] = [];

          // collect headings and generate table of contents
          node.content.forEach((child: PMNode) => {
            if (child.type.name === "heading" && child.attrs.level > 1) {
              const id = child.attrs.id as string;
              const text = child.textContent;
              const level = child.attrs.level as number;
              headings.push(`${"  ".repeat(level - 2)}- [${text}](#${id})`);
            }
          });
          const tocContent = headings.join("\n");

          if (headings) {
            state.write("**Table of contents:**\n" + tocContent + "\n\n");
          }

          // serialize the rest of the content (so the table of contents is at the top of the document)
          state.renderContent(node);

          // final format looks like this:
          // **Table of contents:**
          // - [A heading](#a-heading)
          // - [Another heading](#another-heading)
        },
      },
    };
  },

  addNodeView() {
    return SvelteNodeViewRenderer(Contents);
  },

  addGlobalAttributes() {
    return [
      {
        types: ["heading"],
        attributes: {
          id: {
            default: null,
          },
        },
      },
    ];
  },
});
